/* eslint-disable @typescript-eslint/member-ordering */
import { TabsStore, UserProfileStore } from '../../common/stores';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { endpoints } from '../../../config';
import appClient from '../../common/services/AppClient';
import { HomeShortcut } from '../types';

export default class HomeVisualStore {
    shortcuts: HomeShortcut[] = [];
    shortcutsLoading: boolean = false;

    get welcomeMsg() {
        const { firstName, lastName } = this.userProfileStore.userProfile || {};
        const userDisplayName = firstName && lastName && `${firstName} ${lastName}`;
        return userDisplayName ? `Welcome, ${userDisplayName}!` : 'Welcome!';
    }

    constructor(
        private tabStore: TabsStore,
        private userProfileStore: UserProfileStore
    ) {
        makeObservable(this, {
            shortcuts: observable,
            shortcutsLoading: observable,
            welcomeMsg: computed,
            resetTabSelection: action.bound,
            loadShortcuts: action.bound
        });
    }

    async loadShortcuts() {
        this.shortcutsLoading = true;
        const url = `${endpoints.manageUrl}home-shortcuts/visible`;
        const result = await appClient.get<HomeShortcut[]>(url);
        runInAction(() => {
            if (result.isOk()) {
                this.shortcuts = result.value.sort((a, b) => a.sortOrder - b.sortOrder);
            }
            this.shortcutsLoading = false;
        });
    }

    resetTabSelection() {
        this.tabStore.resetSelection();
    }
}
